import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BasicButton from '../Common/Button/BasicButton';
import { colors } from '@/const/colors';
import { IMAGE_BASE_URL } from '@/const/url';
import '@/css/onBoadingStyle.css';
import Flicking, { EVENTS, MoveStartEvent } from '@egjs/react-flicking';
import '@egjs/react-flicking/dist/flicking.css';

type OnBoadingType = {
  onClickGoHome: () => void;
};

const OnBoading = ({ onClickGoHome }: OnBoadingType) => {
  const lastIndex = 3;
  const navigate = useNavigate();
  const flickingRef = useRef<Flicking>(null);
  const beforeOnboadingRef = useRef<boolean>(false);
  const [isShowGoHome, setIsShowGoHome] = useState<boolean>(false);
  const onBoadingDataList = [
    {
      title: '실차주와 직거래',
      desc: '개인간 직거래로<br/>중간 마진없이 수수료 0원',
      imageUrl: `${IMAGE_BASE_URL}/service_onboading1.jpg`,
    },
    {
      title: '간편하게 차량 등록',
      desc: '차량번호로 정보 조회 후<br/>간편하게 판매 등록하세요',
      imageUrl: `${IMAGE_BASE_URL}/service_onboading2.jpg`,
    },
    {
      title: '내 차량 시세 확인',
      desc: '직트럭 데이터베이스로<br/>적절한 시세를 확인할 수 있어요',
      imageUrl: `${IMAGE_BASE_URL}/service_onboading3.jpg`,
    },
    {
      title: '다양한 서비스',
      desc: '번호판 거래, 운행일지 등<br/>직트럭의 모든 서비스를 이용하세요',
      imageUrl: `${IMAGE_BASE_URL}/service_onboading4.jpg`,
    },
  ];
  const bullet = onBoadingDataList.map((item, index) => ({ isNow: index === 0 }));
  const [bulletList, setBulletList] = useState(bullet);
  const onClickBullet = (index: number) => {
    if (flickingRef.current) {
      flickingRef.current.moveTo(index).catch(() => void 0);
      setIsShowGoHome(index === lastIndex);
    }
  };

  useEffect(() => {
    if (flickingRef.current) {
      flickingRef.current.on(EVENTS.CHANGED, (event) => {
        const updatedBullet = onBoadingDataList.map((_, index) => ({ isNow: index === event.index }));
        setBulletList(updatedBullet);
      });
    }
  }, [onBoadingDataList]);

  const handleCarouselChange = (e: MoveStartEvent<Flicking>) => {
    const { direction } = e;
    const { index } = e.currentTarget;

    const isGoHomeVisible = direction === 'NEXT' && index === lastIndex - 1;
    const isNavigateToLogin = direction === 'NEXT' && index === lastIndex;

    setIsShowGoHome(isGoHomeVisible);

    if (isNavigateToLogin) {
      navigate('/login');
      localStorage.setItem('isFirst', 'false');
    }
  };

  const onClickGoToNext = (index?: number) => {
    if (flickingRef.current) {
      if (index === lastIndex) {
        navigate('/login');
        localStorage.setItem('isFirst', 'false');
      } else {
        flickingRef.current.next().catch(() => void 0);
      }
    }
  };

  return (
    <div className="min-w-[280px] max-w-[720px] w-full min-h-[540px] h-[100dvh] bg-grey-0 flex flex-col justify-center relative">
      <div className="pt-2">
        <Flicking
          ref={flickingRef}
          align="center"
          circular={false}
          renderOnlyVisible={true}
          className="z-0 w-full"
          moveType="strict"
          circularFallback="bound"
          onMoveStart={(e) => handleCarouselChange(e)}
        >
          {onBoadingDataList.map((data, index) => (
            <div
              className="flex flex-col items-center justify-center w-full h-full"
              key={index}
              onClick={() => onClickGoToNext(index)}
            >
              <div className="max-w-[280px] max-h-[300px] min-h-[258px]">
                <img
                  src={data.imageUrl as string}
                  alt="onboading_img"
                  className="object-cover w-full h-full"
                  width={280}
                  height={300}
                />
              </div>
              <div className="text-lg mt-8 text-center leading-[20px]">
                <span className="text-[28px] font-bold text-gray-9">{data.title}</span>
                <p className="mt-[15px] text-gray-8" dangerouslySetInnerHTML={{ __html: data.desc }}></p>
              </div>
            </div>
          ))}
        </Flicking>
        <div className="z-10 flex justify-center py-8 cursor-pointer">
          {bulletList.map((data, index) => (
            <div
              key={index}
              className={`w-3 h-3 rounded-full cursor-pointer m-1 ${data.isNow ? 'bg-[#737373]' : 'bg-[#BEBEBE]'}`}
              onClick={(e) => onClickBullet(index)}
            ></div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-0 flex items-end justify-center py-8 cursor-pointer z-10 px-4 min-w-[280px] max-w-[720px] w-full">
        <BasicButton
          name={!!isShowGoHome ? '홈으로 가기' : '다음'}
          bgColor={colors.primary[10]}
          borderColor={colors.primary[10]}
          textColor={colors.grey[0]}
          fontSize={16}
          height={48}
          fontWeight="bold"
          onClick={() => {
            if (isShowGoHome) {
              onClickGoHome();
            } else {
              onClickGoToNext();
            }
          }}
        />
      </div>
    </div>
  );
};

export default OnBoading;
